import { __decorate } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Model, ModelId } from '@core/shared/model';
import { MaintenanceSettings } from '../models/maintenance-settings';
let GetMaintenanceSettingsRequest = /*#__PURE__*/(() => {
  let GetMaintenanceSettingsRequest = class GetMaintenanceSettingsRequest extends Model {
    static {
      this.Response = MaintenanceSettings;
    }
  };
  GetMaintenanceSettingsRequest = __decorate([AppRequest('admin/maintenance', 'get-settings', {
    httpMethod: AppRequestMethod.GET,
    httpCacheControl: 'no-cache'
  }), ModelId("GetMaintenanceSettingsRequest") // auto-generated by generate-model-ids
  ], GetMaintenanceSettingsRequest);
  return GetMaintenanceSettingsRequest;
})();
export { GetMaintenanceSettingsRequest };